module.exports = __webpack_public_path__ + "img/peche.eb5c320f.png";